import { styled } from '@mui/material/styles';
import { TableCell, TableRow } from '@mui/material';

export const StyledTableRow = styled(TableRow)(() => ({
  '&.Mui-selected': {
    backgroundColor: 'rgba(0 167 111 / 0.08)',
    '&:hover': {
      backgroundColor: 'rgba(145 158 171 / 0.08 + 0.08)',
    },
  },
}));

export const StyledTableCell = styled(TableCell)(() => ({
  borderBottom: '1px dashed #E2E8F0',
  '&.MuiTableCell-head': {
    borderBottom: 'none',
    color: '#647488',
    backgroundColor: '#F1F5F9',
  },
  '&.MuiTableCell-stickyHeader': {
    backgroundColor: '#F1F5F9',
  },
}));
